function formatPixelsToNumber(pixels) {
  if (!pixels) {
    return 0;
  }
  return Number(pixels.replace("px", ""));
}
function formatNumberToPixels(num) {
  return "".concat(num, "px");
}
function getParentInnerWidth(el) {
  const { width, paddingLeft, paddingRight } = window.getComputedStyle(el);
  if (width) {
    return formatPixelsToNumber(width) - formatPixelsToNumber(paddingLeft) - formatPixelsToNumber(paddingRight);
  }
  return 0;
}
function isElementInline(el) {
  return window.getComputedStyle(el).display === "inline";
}
function getElementFontSize(el) {
  return formatPixelsToNumber(window.getComputedStyle(el).fontSize || "0px");
}
function getParentElementParameters(el) {
  const parentEl = el.parentElement;
  const currentParentWidth = parentEl ? getParentInnerWidth(parentEl) : 0;
  const parentFontSize = parentEl ? getElementFontSize(parentEl) : 0;
  return { currentParentWidth, parentFontSize };
}
export {
  formatNumberToPixels,
  formatPixelsToNumber,
  getElementFontSize,
  getParentElementParameters,
  getParentInnerWidth,
  isElementInline
};
